import type { WorkflowDiagramToolData } from './useWorkflowDiagramToolData.types';

import { useMemo, useState } from 'react';
import { useEdgesState, useNodesState } from 'reactflow';

export const useWorkflowDiagramToolData = (): WorkflowDiagramToolData => {
  const [diagramInstance, setDiagramInstance] =
    useState<WorkflowDiagramToolData['localState']['diagramInstance']>(null);
  const [isReadyForPrint, setIsReadyForPrint] =
    useState<WorkflowDiagramToolData['localState']['isReadyForPrint']>(false);

  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);

  const localState: WorkflowDiagramToolData['localState'] = {
    diagramInstance,
    nodes,
    edges,
    isReadyForPrint
  };

  const localActions: WorkflowDiagramToolData['localActions'] = useMemo(
    () => ({
      setDiagramInstance,
      setNodes,
      setEdges,
      setIsReadyForPrint,
      onNodesChange,
      onEdgesChange
    }),
    [onEdgesChange, onNodesChange, setEdges, setNodes]
  );

  return {
    localState,
    localActions
  };
};
